import { render, staticRenderFns } from "./SalaryPeriodConfigList.vue?vue&type=template&id=0c9e1f65&scoped=true"
import script from "./SalaryPeriodConfigList.vue?vue&type=script&lang=js"
export * from "./SalaryPeriodConfigList.vue?vue&type=script&lang=js"
import style0 from "./SalaryPeriodConfigList.vue?vue&type=style&index=0&id=0c9e1f65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9e1f65",
  null
  
)

export default component.exports